import { isCallActive } from './callActivity';
import { isGroupCallBusy } from './groupCallBridge';

const CHECK_INTERVAL_MS = 5 * 60 * 1000; // 5분
let lastHiddenTime = 0;
let lastCheckTime = 0;
let isInitialized = false;

/**
 * 오래 켜 둔 앱 화면 복귀 시 조용한 버전 갱신 감시자 시작
 */
export function initVersionCheck() {
  if (isInitialized || typeof window === 'undefined') return;
  isInitialized = true;

  document.addEventListener('visibilitychange', () => {
    const now = Date.now();

    if (document.visibilityState === 'hidden') {
      lastHiddenTime = now;
      return;
    }

    if (document.visibilityState === 'visible') {
      // 1. 숨겨져 있던 시간이 5분 미만이면 검사하지 않음
      if (!lastHiddenTime || now - lastHiddenTime < CHECK_INTERVAL_MS) {
        return;
      }

      // 2. 검사 간격 최소 5분 유지
      if (lastCheckTime && now - lastCheckTime < CHECK_INTERVAL_MS) {
        return;
      }

      lastCheckTime = now;

      // 3. 로컬/개발 모드면 검사 건너뜀
      const currentBuildId = import.meta.env.VITE_BUILD_ID;
      if (!currentBuildId || currentBuildId === 'dev') {
        return;
      }

      // 4. 서버 버전 확인
      fetch(`/version.json?t=${now}`, { cache: 'no-store' })
        .then((res) => (res.ok ? res.json() : null))
        .then((data) => {
          if (!data?.build || data.build === currentBuildId) {
            return;
          }

          // [새 버전 감지됨] 갱신 가능 조건 검사
          // 조건 1: 통화 중 여부
          if (isCallActive() || isGroupCallBusy()) {
            console.log('[새 버전] 감지 — 보류(통화 중)');
            return;
          }

          // 조건 2: 통화 복구용 새로고침 진행 중 여부
          try {
            const hasRecoveryInfo =
              Boolean(sessionStorage?.getItem('moowoo_call_recovery')) ||
              Boolean(localStorage?.getItem('moowoo_call_recovery'));
            if (hasRecoveryInfo) {
              console.log('[새 버전] 감지 — 보류(통화 복구 진행 중)');
              return;
            }
          } catch {}

          // 조건 3: 현재 경로가 결제·첫 설정 경로가 아님
          const pathname = window.location.pathname || '';
          if (
            pathname.startsWith('/checkout') ||
            pathname.startsWith('/payment/result') ||
            pathname === '/onboarding' ||
            pathname === '/setup-profile'
          ) {
            console.log(`[새 버전] 감지 — 보류(보호 경로: ${pathname})`);
            return;
          }

          // 조건 4-A: 보내지 않은 채팅 입력 글 보호
          const guardedInputs = Array.from(document.querySelectorAll('[data-unsent-guard]'));
          const hasUnsentChat = guardedInputs.some((el) => Boolean(el.value && el.value.trim().length > 0));
          if (hasUnsentChat) {
            console.log('[새 버전] 감지 — 보류(보내지 않은 채팅 글)');
            return;
          }

          // 조건 4-B: 타이핑 중 보호 (현재 활성 입력 요소)
          const active = document.activeElement;
          if (active) {
            const isTextarea = active.tagName === 'TEXTAREA';
            const textInputTypes = new Set(['', 'text', 'search', 'email', 'url', 'tel', 'password', 'number']);
            const isTextInput = active.tagName === 'INPUT' && textInputTypes.has(active.getAttribute('type') || active.type || '');
            const isEditableInput = (isTextarea || isTextInput) && !active.readOnly && !active.disabled;
            const isContentEditable = active.isContentEditable || active.getAttribute('contenteditable') === 'true';

            if (isEditableInput || isContentEditable) {
              console.log('[새 버전] 감지 — 보류(입력 중)');
              return;
            }
          }

          // 모든 조건 충족: 조용히 새로고침
          console.log('[새 버전] 감지 — 조용히 갱신');
          window.location.reload();
        })
        .catch(() => {
          // fetch 실패 시 아무것도 하지 않음
        });
    }
  });
}
